<template lang="pug">
  .container-landing
    router-view
</template>

<script>
/* eslint-disable */
export default {
  name: 'Public',
  data () {
    return {
      home: process.env.LANDING_URL || 'https://www.interseguro.pe'
    }
  },
  mounted () {
    // this.$amplitude.getInstance().identify(new this.$amplitude.Identify())
  }
}
</script>

<style>
@import url('../assets/css/general.css');
@import url('../assets/css/public.css');

.container-landing {
  margin-top: 90px;
}

p.text-right.siguenos-en {
  color: #fff;
  margin-bottom: 1rem;
}

p.correo-footer {
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/layouts/Public.vue